module.exports = __webpack_public_path__ + "img/expoaid.56b8a3b1.jpg";